// @flow
import React from 'react';
import _ from 'lodash';
import styled from 'styled-components';
import * as RenterApp from 'styles/Home/StyledRenterApplication';
import BackButton from 'components/renter_application/BackButtonComponent';
import UploadFiles from 'components/renter_application/UploadFilesComponent';
import IdCard from 'AssetsRoot/images/homie_v3/id_card.svg.react';
import FileImage from 'AssetsRoot/images/homie_v3/file.svg.react';
import SpacialFileImage from 'AssetsRoot/images/homie_v3/special_file.svg.react';
import Asset from 'models/homes/Asset';
import HomeApplicationActions from 'actions/HomeApplicationActions';
import HomeApplicationStore from 'stores/HomeApplicationStore';
import { LEGAL_PERSON_CONST } from 'utils/Constants';
import $_ from 'jquery';
import {
  isValidFileType,
  isValidFileSize,
  maxFileSizeMessage,
  ValidFileTypesOnDocuments
} from 'validations/HomieValidations';
import { Form, Formik } from 'formik';
import PaymentMethodStore from 'stores/PaymentMethodStore';
import PaymentMethodActions from 'actions/PaymentMethodActions';

const Title = styled(RenterApp.Title)`
  margin-bottom: 10px;
`;
const IdCardIcon = styled(IdCard)`
  height: 40px;
  width: 64px;
`;
const FileIcon = styled(FileImage)`
  height: 50px;
  width: 40px;
`;
const SpecialFileIcon = styled(SpacialFileImage)`
  height: 50px;
  width: 40px;
`;
const IdCardIconRed = styled(IdCardIcon)`
  & g {
    fill: #ff1a00;
  }
`;
const FileIconRed = styled(FileIcon)`
  & g {
    fill: #ff1a00;
    stroke: #ff1a00;
  }
`;
const SpecialFileIconRed = styled(SpecialFileIcon)`
  & g {
    fill: #ff1a00;
    stroke: #ff1a00;
  }
`;

const ErrorMessage = styled.span`
  display: block;
  height: ${props => (props.visible ? '15px' : '0')};
  width: 183px;
  color: #ff1a00;
  font-size: 12px;
  line-height: 15px;
  margin-top: ${props => (props.visible ? '4px' : '0')};
  margin-bottom: 30px;
  transition: all 0.2s linear;
  width: 100%;
`;

type PropsType = {
  homeApplication: any,
  onChange: (any, any) => void,
  nextAction: () => void,
  onPrevStep: () => void,
  onCancel: () => void
};

type State = {
  constitutiveActFilesLoaded: Array<Asset>,
  annualStatementsFilesLoaded: Array<Asset>,
  idFilesLoaded: Array<Asset>,
  constitutiveActFilesValidationError: boolean,
  annualStatementsFilesValidationError: boolean,
  idFilesValidationError: boolean,
  errorMessage: string,
  succesCode: null,
  errorCode: null,
  errorPaymentPromo: boolean,
  correctPayment: boolean,
  paymentData: any
};

export default class DocumentsContentComponent extends React.Component<
  PropsType,
  State
> {
  state = {
    constitutiveActFilesLoaded: [],
    annualStatementsFilesLoaded: [],
    idFilesLoaded: [],
    constitutiveActFilesValidationError: false,
    annualStatementsFilesValidationError: false,
    idFilesValidationError: false,
    errorMessage: '',
    succesCode: null,
    errorCode: null,
    errorPaymentPromo: false,
    correctPayment: false,
    paymentData: null
  };

  componentWillMount() {
    HomeApplicationStore.addAssetsChangeListener(this.onAssetsLoaded);
  }

  componentDidMount() {
    const application_id = _.get(this.props.homeApplication, 'id');
    HomeApplicationActions.getMaxAssetSize();
    HomeApplicationActions.listHomeApplicationAssets(
      application_id,
      'constitutive_acts'
    );
    HomeApplicationActions.listHomeApplicationAssets(
      application_id,
      'annual_statements'
    );
    HomeApplicationActions.listHomeApplicationAssets(
      application_id,
      'identifications'
    );
  }

  componentWillUnmount() {
    HomeApplicationStore.removeAssetsChangeListener(this.onAssetsLoaded);
  }

  onAssetsLoaded = () => {
    const uploadError = HomeApplicationStore.getAssetUploadError();

    this.setState({
      constitutiveActFilesLoaded: HomeApplicationStore.getHomeApplicationAssetsByType(
        'constitutive_acts'
      ),
      annualStatementsFilesLoaded: HomeApplicationStore.getHomeApplicationAssetsByType(
        'annual_statements'
      ),
      idFilesLoaded: HomeApplicationStore.getHomeApplicationAssetsByType(
        'identifications'
      ),
      ...(uploadError
        ? {
            errorMessage: uploadError.message,
            constitutiveActFilesValidationError:
              uploadError.asset_type === 'constitutive_acts',
            annualStatementsFilesValidationError:
              uploadError.asset_type === 'annual_statements',
            idFilesValidationError: uploadError.asset_type === 'identifications'
          }
        : {})
    });
  };

  _uploadConstitutiveActFile = (
    file: File,
    assetTmpId: string
  ): Promise<any> => {
    if (isValidFileType(file, ValidFileTypesOnDocuments)) {
      HomeApplicationActions.uploadAsset(
        this.props.homeApplication.id,
        'constitutive_acts',
        file,
        assetTmpId
      );
    }
  };

  _uploadAnnualStatementsFile = (
    file: File,
    assetTmpId: string
  ): Promise<any> => {
    if (isValidFileType(file, ValidFileTypesOnDocuments)) {
      HomeApplicationActions.uploadAsset(
        this.props.homeApplication.id,
        'annual_statements',
        file,
        assetTmpId
      );
    }
  };

  _uploadIdFile = (file: File, assetTmpId: string): Promise<any> => {
    if (isValidFileType(file, ValidFileTypesOnDocuments)) {
      HomeApplicationActions.uploadAsset(
        this.props.homeApplication.id,
        'identifications',
        file,
        assetTmpId
      );
    }
  };

  _onSelectConstitutiveActFiles = (files: Array<File>): void => {
    let assetsLoadedTemp = JSON.parse(
      JSON.stringify(this.state.constitutiveActFilesLoaded)
    );
    for (let i = 0; i < files.length; ++i) {
      if (isValidFileType(files[i], ValidFileTypesOnDocuments)) {
        const maxAssetSize = HomeApplicationStore.getMaxAssetSize();
        if (!isValidFileSize(files[i], maxAssetSize)) {
          this.setState({
            constitutiveActFilesValidationError: true,
            errorMessage: maxFileSizeMessage(maxAssetSize)
          });
          continue;
        }
        this.setState({ constitutiveActFilesValidationError: false });
        const file = files[i];
        if (LEGAL_PERSON_CONST.MAX_IMAGES > assetsLoadedTemp.length) {
          const assetLoaded = new Asset(
            `id${i}`,
            '',
            '',
            'constitutive_acts',
            file
          );
          HomeApplicationActions.addTmpAsset(assetLoaded);
        } else {
          break;
        }
      } else {
        this.setState({
          constitutiveActFilesValidationError: true,
          errorMessage: 'Ingresa un tipo de archivo válido.'
        });
      }
    }
  };

  _onSelectAnnualStatementsFiles = (files: Array<File>): void => {
    let assetsLoadedTemp = JSON.parse(
      JSON.stringify(this.state.annualStatementsFilesLoaded)
    );
    for (let i = 0; i < files.length; ++i) {
      if (isValidFileType(files[i], ValidFileTypesOnDocuments)) {
        const maxAssetSize = HomeApplicationStore.getMaxAssetSize();
        if (!isValidFileSize(files[i], maxAssetSize)) {
          this.setState({
            annualStatementsFilesValidationError: true,
            errorMessage: maxFileSizeMessage(maxAssetSize)
          });
          continue;
        }
        this.setState({ annualStatementsFilesValidationError: false });
        const file = files[i];
        if (LEGAL_PERSON_CONST.MAX_IMAGES >= assetsLoadedTemp.length) {
          const assetLoaded = new Asset(
            `${i}`,
            '',
            '',
            'annual_statements',
            file
          );
          HomeApplicationActions.addTmpAsset(assetLoaded);
        } else {
          break;
        }
      } else {
        this.setState({
          annualStatementsFilesValidationError: true,
          errorMessage: 'Ingresa un tipo de archivo válido.'
        });
      }
    }
  };

  _onSelectIdFiles = (files: Array<File>): void => {
    let assetsLoadedTemp = JSON.parse(JSON.stringify(this.state.idFilesLoaded));
    for (let i = 0; i < files.length; ++i) {
      if (isValidFileType(files[i], ValidFileTypesOnDocuments)) {
        const maxAssetSize = HomeApplicationStore.getMaxAssetSize();
        if (!isValidFileSize(files[i], maxAssetSize)) {
          this.setState({
            idFilesValidationError: true,
            errorMessage: maxFileSizeMessage(maxAssetSize)
          });
          continue;
        }
        this.setState({ idFilesValidationError: false });
        const file = files[i];
        if (LEGAL_PERSON_CONST.MAX_IMAGES >= assetsLoadedTemp.length) {
          const assetLoaded = new Asset(
            `${i}`,
            '',
            '',
            'identifications',
            file
          );
          HomeApplicationActions.addTmpAsset(assetLoaded);
        } else {
          break;
        }
      } else {
        this.setState({
          idFilesValidationError: true,
          errorMessage: 'Ingresa un tipo de archivo válido.'
        });
      }
    }
  };

  _handleDeleteConstitutiveActFileLoaded = (id: string | number): void => {
    HomeApplicationActions.deleteAsset(
      this.props.homeApplication.id,
      id,
      'constitutive_acts'
    );
  };

  _handleDeleteAnnualStatementsFileLoaded = (id: string | number): void => {
    HomeApplicationActions.deleteAsset(
      this.props.homeApplication.id,
      id,
      'annual_statements'
    );
  };

  _handleDeleteIdFileLoaded = (id: string | number): void => {
    HomeApplicationActions.deleteAsset(
      this.props.homeApplication.id,
      id,
      'identifications'
    );
  };

  submitData = (event: any): void => {
    event.preventDefault();
    if (this.checkValidation()) {
      this.props.onChange({ step: 'documents' });
    } else {
      $_('html, body, #Wrapper').animate({ scrollTop: 0 }, 500);
    }
  };

  checkValidation = (): boolean => {
    let validationSuccess = true;
    if (this.state.constitutiveActFilesLoaded.length <= 0) {
      this.setState({
        constitutiveActFilesValidationError: true,
        errorMessage: 'Al menos una imágen es requerida.'
      });
      validationSuccess = false;
    }
    if (this.state.annualStatementsFilesLoaded.length <= 0) {
      this.setState({
        annualStatementsFilesValidationError: true,
        errorMessage: 'Al menos una imágen es requerida.'
      });
      validationSuccess = false;
    }
    if (this.state.idFilesLoaded.length <= 0) {
      this.setState({
        idFilesValidationError: true,
        errorMessage: 'Al menos una imágen es requerida.'
      });
      validationSuccess = false;
    }
    return validationSuccess;
  };

  isDisabled = (): boolean => {
    if (
      this.state.constitutiveActFilesLoaded.length <
        LEGAL_PERSON_CONST.MIN_CONSTITUTIVE_IMAGES ||
      this.state.annualStatementsFilesLoaded.length <
        LEGAL_PERSON_CONST.MIN_STATEMENTS_IMAGES ||
      this.state.idFilesLoaded.length < LEGAL_PERSON_CONST.MIN_ID_IMAGES ||
      !_.every(
        this.state.constitutiveActFilesLoaded,
        asset => asset.file === null
      ) ||
      !_.every(
        this.state.annualStatementsFilesLoaded,
        asset => asset.file === null
      ) ||
      !_.every(this.state.idFilesLoaded, asset => asset.file === null)
    ) {
      return true;
    }
    return false;
  };

  checkCouponValidation = (): boolean => {
    let validationSuccess = true;
    if (this.state.idFilesLoaded.length <= 0) {
      this.setState({
        idFilesValidationError: true,
        errorMessage: 'Al menos una imágen es requerida.'
      });
      validationSuccess = false;
    }
    return validationSuccess;
  };

  defaultValues = (): {} => {
    return {
      discountCoupon: 'appa9660e'
    };
  };

  handleClickPromoCode = (values: any): void => {
    if (values && values.discountCoupon) {
      this.checkCouponValidation();
    }

    HomeApplicationActions.validateHomeApplicationPromoCode(
      values.discountCoupon,
      { home_application_id: this.props.homeApplication.id },
      this.succesPromoCode,
      this.errorPromoCode
    );
  };

  payHomeApplicationCompletePromoCode = (promoCode: string) => {
    let payObject = {
      home_application_id: this.props.homeApplication.id,
      payment_method: 'promo',
      promo_code: 'appa9660e'
    };

    PaymentMethodActions.payApplicationByMethod(
      payObject,
      this.props.homeApplication.id,
      this.successPayByPromo
    );
  };

  successPayByPromo = () => {
    this.setState({
      errorPaymentPromo: false,
      correctPayment: true,
      paymentData: PaymentMethodStore.payApplicationByMethod()
    });
    window.location.href = `/h/inquilino/${this.props.homeApplication.id}/aplicacion-completada`;
  };

  succesPromoCode = (): void => {
    this.setState({
      succesCode: HomeApplicationStore.getCodeValidate(),
      errorCode: null
    });
    HomeApplicationStore.flushAssets();
    PaymentMethodStore.flushPaymentData();

    this.payHomeApplicationCompletePromoCode();
  };

  errorPromoCode = (): void => {
    alert('Hubo un error inesperado al finalizar la aplicación');
    this.setState({
      errorCode: HomeApplicationStore.getCodeValidateError(),
      succesCode: null
    });
  };

  render() {
    return (
      <RenterApp.AppTabContainer>
        <RenterApp.BackButtonContainer onClick={this.props.onPrevStep}>
          <BackButton text={'Referencias'} />
        </RenterApp.BackButtonContainer>
        <RenterApp.AppTabForm>
          <form onSubmit={this.submitData}>
            <Title>Acta constitutiva de la empresa</Title>
            <RenterApp.Text>
              Sube una fotografía o el documento escaneado.
            </RenterApp.Text>
            <UploadFiles
              Icon={SpecialFileIcon}
              IconError={SpecialFileIconRed}
              assetsLoaded={this.state.constitutiveActFilesLoaded}
              uploadFileAction={this._uploadConstitutiveActFile}
              onSelectFiles={this._onSelectConstitutiveActFiles}
              onDeleteFileLoaded={this._handleDeleteConstitutiveActFileLoaded}
              instruction={'Suelta aquí tus archivos'}
              textButton={'Añadir archivos'}
              haveError={this.state.constitutiveActFilesValidationError}
              acceptFile={ValidFileTypesOnDocuments}
            />
            <ErrorMessage
              visible={this.state.constitutiveActFilesValidationError}
            >
              {this.state.constitutiveActFilesValidationError
                ? this.state.errorMessage
                : ''}
            </ErrorMessage>
            <RenterApp.EndSectionSpace />
            <Title>Declaración anual de la empresa</Title>
            <RenterApp.Text>
              Sube la última declaración anual presentada ante el SAT en formato
              PDF y el acta constitutiva de la empresa donde se especifica el
              nombre del apoderado legal.
            </RenterApp.Text>
            <UploadFiles
              Icon={FileIcon}
              IconError={FileIconRed}
              assetsLoaded={this.state.annualStatementsFilesLoaded}
              uploadFileAction={this._uploadAnnualStatementsFile}
              onSelectFiles={this._onSelectAnnualStatementsFiles}
              onDeleteFileLoaded={this._handleDeleteAnnualStatementsFileLoaded}
              instruction={'Suelta aquí tus archivos'}
              textButton={'Añadir archivos'}
              haveError={this.state.annualStatementsFilesValidationError}
              acceptFile={ValidFileTypesOnDocuments}
            />
            <ErrorMessage
              visible={this.state.annualStatementsFilesValidationError}
            >
              {this.state.annualStatementsFilesValidationError
                ? this.state.errorMessage
                : ''}
            </ErrorMessage>
            <RenterApp.EndSectionSpace />
            <Title>
              Identificación oficial vigente del representante legal y del
              inquilino
            </Title>
            <RenterApp.Text>
              Sube una fotografía de cada identificación oficial vigente. IFE,
              INE <strong>por delante y por detrás</strong> o pasaporte y FM en
              caso de ser extranjero.
            </RenterApp.Text>
            <UploadFiles
              Icon={IdCard}
              IconError={IdCardIconRed}
              assetsLoaded={this.state.idFilesLoaded}
              uploadFileAction={this._uploadIdFile}
              onSelectFiles={this._onSelectIdFiles}
              onDeleteFileLoaded={this._handleDeleteIdFileLoaded}
              instruction={'Suelta aquí tus archivos'}
              textButton={'Añadir archivos'}
              haveError={this.state.idFilesValidationError}
              acceptFile={ValidFileTypesOnDocuments}
            />
            <ErrorMessage visible={this.state.idFilesValidationError}>
              {this.state.idFilesValidationError ? this.state.errorMessage : ''}
            </ErrorMessage>
            <RenterApp.EndSectionSpace />
          </form>
        </RenterApp.AppTabForm>
        <Formik
          onSubmit={this.handleClickPromoCode}
          initialValues={this.defaultValues()}
        >
          <Form>
            <RenterApp.SubmitButton disabled={this.isDisabled()} type="submit">
              Finalizar aplicación
            </RenterApp.SubmitButton>
          </Form>
        </Formik>
        <RenterApp.CancelAppButton onClick={this.props.onCancel}>
          Cancelar aplicación
        </RenterApp.CancelAppButton>
      </RenterApp.AppTabContainer>
    );
  }
}
